import { LightBoxOfferInfoEntity } from "@modules/boxOffer/entities/lightBoxOfferInfoEntity"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { type BoxPromoCodeDto } from "@modules/promoCode/gateway/boxPromoCodeDto"
import { PromoCodeStatus } from "@modules/promoCode/gateway/promoCodeDto"

export class BoxPromoCodeEntity {
  private constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly code: string,
    public readonly type: CouponType,
    public readonly value: number,
    public readonly createdAt: Date,
    public readonly startAt: Date | null,
    public readonly expirationDate: Date | null,
    public readonly durationInMonths: number | null,
    public readonly maxAttendees: number | null,
    public readonly onlyNewCustomer: boolean,
    public readonly boxOffers: LightBoxOfferInfoEntity[],
    public readonly archived: boolean,
    public readonly archivedStatus: PromoCodeStatus | null,
  ) {}

  static fromDto(dto: BoxPromoCodeDto): BoxPromoCodeEntity {
    return new BoxPromoCodeEntity(
      dto.id,
      dto.title,
      dto.code,
      dto.type,
      dto.value,
      new Date(dto.createdAt),
      dto.startAt ? new Date(dto.startAt) : null,
      dto.expirationDate ? new Date(dto.expirationDate) : null,
      dto.durationInMonths ?? null,
      dto.maxAttendees ?? null,
      dto.onlyNewCustomer,
      dto.boxOffers.map((bo) => LightBoxOfferInfoEntity.fromDto(bo)),
      dto.archived,
      dto.archivedStatus ?? null,
    )
  }
}
